import {
    CREATE_WADADDY_CREDENTIAL,
    UPDATE_WADADDY_CREDENTIAL,
    GET_WADADDY_CREDENTIAL,
    GET_WADADDY_BALANCE,
} from '../actions/WaDaddy.action';

const initialState = {
    createWaDaddyCredential: '',
    updateWaDaddyCredential: '',
    getWaDaddyCredential: '',
    getWaDaddyBalance: '',
};

const WaDaddyReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_WADADDY_CREDENTIAL:
            return { ...state, createWaDaddyCredential: action.payload };
        case UPDATE_WADADDY_CREDENTIAL:
            return { ...state, updateWaDaddyCredential: action.payload };
        case GET_WADADDY_CREDENTIAL:
            return { ...state, getWaDaddyCredential: action.payload };
        case GET_WADADDY_BALANCE:
            return { ...state, getWaDaddyBalance: action.payload };
        default:
            return { ...state };
    }
};

export default WaDaddyReducer;